const refreshingRecs = {};

export const placements = {
  RECOMMENDATIONS_OOS_PLACEMENT: 'OSPStandardOos',
  RECOMMENDATIONS_A2B_PLACEMENT: 'OSPStandardA2BClick',
}

export const refreshRecommendationsForPlacement = (placement) => {
  const { data: { placements = [] } = {} } = window.jlRecs || {};
  const existingPlacementData = placements.some((p) => p.requestedPlacement === placement);
  const refreshPlacement = (placementName) => {
    if (window.jlRecs.refresh && !refreshingRecs[placement]) {
      refreshingRecs[placement] = true;
      window.jlRecs.refresh([ placementName ])
        .then(() => refreshingRecs[placement] = false)
        .catch(() => refreshingRecs[placement] = false)
    }
  };

  if (!existingPlacementData) {
    if (window.jlRecs) {
      return refreshPlacement(placement);
    }
    window.jlRecs = {
      onReady: () => refreshPlacement(placement)
    }
  }
}